<on-screen-keyboard class="keypad" [customLayout]="layout" (keyPress)="keyPress($event)"
  [keyboardType]="keyboardType"></on-screen-keyboard>
